<div
  *transloco="let t; prefix: 'shared.statusBar'"
  [matTooltip]="getTooltipText()"
  [matTooltipPosition]="'above'"
  [matTooltipDisabled]="isTooltipDisabled()"
  class="inline-block"
>
  <button
    mat-flat-button
    class="!mr-4 text-label-large"
    [disabled]="isButtonDisabled()"
    (click)="showCompareView()"
  >
    {{ t('compare') }}
  </button>
</div>
